/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseNavigationMenuFragment, NavigationMenuFragment, FullNavigationMenuFragment} from '@amblique/contentful/app/contentful/fragments/navigation-menu';

/**
 * Get a single NavigationMenu by ID (base - scalars only)
 */
export const getBaseNavigationMenuById = gql`
  ${BaseNavigationMenuFragment}

  query GetBaseNavigationMenuById($id: String!, $locale: String!, $preview: Boolean) {
    navigationMenu(id: $id, locale: $locale, preview: $preview) {
      ...BaseNavigationMenuFragment
    }
  }
`;

/**
 * Get a single NavigationMenu by ID (standard - 1 level deep)
 */
export const getNavigationMenuById = gql`
  ${NavigationMenuFragment}

  query GetNavigationMenuById($id: String!, $locale: String!, $preview: Boolean) {
    navigationMenu(id: $id, locale: $locale, preview: $preview) {
      ...NavigationMenuFragment
    }
  }
`;

/**
 * Get a single NavigationMenu by ID (full - 2 levels deep)
 */
export const getFullNavigationMenuById = gql`
  ${FullNavigationMenuFragment}

  query GetFullNavigationMenuById($id: String!, $locale: String!, $preview: Boolean) {
    navigationMenu(id: $id, locale: $locale, preview: $preview) {
      ...FullNavigationMenuFragment
    }
  }
`;

/**
 * Get all NavigationMenu entries with pagination (base - scalars only)
 */
export const getBaseNavigationMenus = gql`
  ${BaseNavigationMenuFragment}

  query GetBaseNavigationMenus(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [NavigationMenuOrder]
    $where: NavigationMenuFilter
    $preview: Boolean
  ) {
    navigationMenuCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseNavigationMenuFragment
      }
    }
  }
`;

/**
 * Get all NavigationMenu entries with pagination (standard - 1 level deep)
 */
export const getNavigationMenus = gql`
  ${NavigationMenuFragment}

  query GetNavigationMenus(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [NavigationMenuOrder]
    $where: NavigationMenuFilter
    $preview: Boolean
  ) {
    navigationMenuCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...NavigationMenuFragment
      }
    }
  }
`;

/**
 * Get all NavigationMenu entries with pagination (full - 2 levels deep)
 */
export const getFullNavigationMenus = gql`
  ${FullNavigationMenuFragment}

  query GetFullNavigationMenus(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [NavigationMenuOrder]
    $where: NavigationMenuFilter
    $preview: Boolean
  ) {
    navigationMenuCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullNavigationMenuFragment
      }
    }
  }
`;
